export const getMap = (state) => state.map;
